const sumM = (array1, array2) =>
  array1.map((value, index) => array2[index] + value)

export const sumSquareMatrix = matrix => {
  return matrix.reduce(sumM)
}
